import styled from 'styled-components';
import React from 'react';

export const CabinetAndFormButtonContainer = styled.div`
  align-items: center;
  justify-content: space-between;
  display: none;

  @media (max-width: 850px) {
    display: flex;
  }

  @media (max-width: 512px) {
    padding: 0 8px;
  }

  @media (max-width: 320px) {
    margin-bottom: 12px;
  }
`;
